// Turns a diff's raw dotted path (e.g.
// "document_types.memorandum_of_sale.identification.min_supporting_matches")
// into a human-readable breadcrumb ("Document Types > memorandum_of_sale >
// Identification > Min Supporting Matches") - never a raw JSON path, per
// PRD 07 AC1. Every segment is shown (nothing dropped) so this stays
// generic across all 7 file_keys, including the 3 with no dedicated editor
// screen in this app (global_defaults, extractors, chunking_profiles) and
// therefore no established per-shape "which segments are noise" convention
// to crib from. A purely numeric segment (a list index) renders as a
// 1-indexed "#N" instead of being title-cased.
function humanizeSegment(segment: string): string {
  if (/^\d+$/.test(segment)) {
    return `#${Number(segment) + 1}`
  }
  return segment
    .split('_')
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    .join(' ')
}

export function humanizePath(path: string): string {
  return path.split('.').map(humanizeSegment).join(' > ')
}
